export const messages = {
  en: {
    roomOweFeeCallable: {
      title: 'Urge Arrears',
      callableWay: 'Urge Method',
      selectCallableWay: 'Please select urge method',
      callableFees: 'Urge Fees', 
      remark: 'Urge Remark',
      inputRemark: 'Please input remark',
      callableWayRequired: 'Urge method is required',
      fetchFeeError: 'Failed to get fee list'
    }
  },
  zh: {
    roomOweFeeCallable: {
      title: '催缴欠费',
      callableWay: '催缴方式',
      selectCallableWay: '请选择催缴方式',
      callableFees: '催缴费用',
      remark: '催缴说明',
      inputRemark: '请输入备注',
      callableWayRequired: '催缴方式不能为空',
      fetchFeeError: '获取费用列表失败'
    }
  },
  'zh-TW': {
    roomOweFeeCallable: {
      title: '催繳欠費',
      callableWay: '催繳方式',
      selectCallableWay: '請選擇催繳方式',
      callableFees: '催繳費用',
      remark: '催繳說明',
      inputRemark: '請輸入備註',
      callableWayRequired: '催繳方式不能為空',
      fetchFeeError: '獲取費用列表失敗'
    }
  }
}